import { CloseContainer } from "./styles";
import { toast } from "components/ui/use-toast";
import { useDialogModal } from "../../../../../hook/handle-modal/hooks/actions";
import { LoadingDots } from "components/loadingDots";
import {
  useGetStoresConciliationsQuery,
  useOpenConciliationMutation,
} from "../../../../../services/store-conciliation";
import { useCurrentConciliation, setConciliationStatus } from "../components/divergence-list/ducks/filter/hooks/statusConciliation";
import { useDispatch } from "react-redux";
import { Button } from "components/ui/button";

interface OpenConciliationProps {
  conciliation_id: string;
}

export const OpenConciliation: React.FC<OpenConciliationProps> = ({
  conciliation_id,
}) => {
  const { handleModal } = useDialogModal();
  const dispatch = useDispatch();
  const { refetch } = useGetStoresConciliationsQuery({});
  const [openConciliation, { isLoading: isOpenLoading }] =
    useOpenConciliationMutation();

  const { isClosed } = useCurrentConciliation();

  const handleSave = async () => {
    if (isClosed) {
      toast({
        variant: "destructive",
        description: "Esta conciliação já está fechada e não pode ser reaberta!",
        duration: 5000,
      });
      return;
    }

    try {
      await openConciliation(conciliation_id as string).unwrap();

      // Update Redux state when conciliation is opened
      dispatch(
        setConciliationStatus({
          id: conciliation_id,
          isClosed: false,
        })
      );

      refetch();
      toast({
        variant: "default",
        description: "Conciliação aberta com sucesso!",
        duration: 2000,
      });
    } catch (e) {
      toast({
        variant: "destructive",
        description: "Algo não saiu como esperado!",
        duration: 5000,
      });
    }
    handleModal({
      isOpen: false,
    });
  };

  return (
    <>
      <CloseContainer className="max-h-[90vh] overflow-auto">
        <h1 className="title">
          {isClosed
            ? "Esta conciliação já está fechada!"
            : "Tem certeza que deseja abrir a Conciliação?"}
        </h1>
        {isClosed && (
          <p className="text-gray-600 text-sm mt-2">
            Conciliações fechadas não podem ser reabertas.
          </p>
        )}
        <div className="flex items-end justify-end gap-2 my-2">
          <Button
            disabled={isOpenLoading}
            type="button"
            variant="outline"
            onClick={() =>
              handleModal({
                isOpen: false,
              })
            }
          >
            {isClosed ? "Fechar" : "Voltar"}
          </Button>
          {!isClosed && (
            <Button
              className="save"
              onClick={handleSave}
              disabled={isOpenLoading || isClosed}
            >
              <LoadingDots isLoading={isOpenLoading} text={"Abrir Conciliação"} />
            </Button>
          )}
        </div>
      </CloseContainer>
    </>
  );
};
